module.exports = __webpack_public_path__ + "img/come-vict-05.69ecfad1.jpg";